import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerTranslationsPage from "../pages/DsokCustomerTranslationsPage";

export const dsokCustomerTranslationsRoute = {
  path: "/dsok/customer-detail/:customerUrl/translations",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerTranslationsPage} />
    </DsokCustomerDetailProvider>
  ),
};
